// extracted by mini-css-extract-plugin
export var bodySections = "_9a-8";
export var gray = "_9a-7";
export var green = "_9a-4";
export var iconContainer = "_9a-9";
export var iconWidgetContainer = "_9a-1";
export var phoneIcon = "_9a-2";
export var red = "_9a-5";
export var statusDot = "_9a-3";
export var widgetContainer = "_9a-0";
export var yellow = "_9a-6";